import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSeguimientoTaller } from "../../services/apis";
import {
	Grid,
	Card,
	CardContent,
	CardHeader,
	Typography,
	CircularProgress,
	Alert,
	Stepper,
	Step,
	StepLabel,
	IconButton,
	Button,
	useMediaQuery, // 📌 Importamos useMediaQuery
	useTheme, // 📌 Importamos useTheme
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export const TareaCliente = () => {
	const { id } = useParams();
	const [tareaInfo, setTareaInfo] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [estados, setEstados] = useState([]);

	// 📌 Obtener tema de Material UI
	const theme = useTheme();
	// 📌 Detectar si la pantalla es menor a 600px (móvil)
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	useEffect(() => {
		const cargarSeguimiento = async () => {
			try {
				const response = await getSeguimientoTaller(id);
				setTareaInfo(response.data.tarea);
				setEstados(response.data.estados);
			} catch (err) {
				setError("Error al cargar la información.");
			} finally {
				setLoading(false);
			}
		};

		cargarSeguimiento();
	}, [id]);

	return (
		<Grid
			container
			justifyContent="center"
			alignItems="center"
			minHeight="100vh"
			padding={2}
		>
			{loading ? (
				<CircularProgress size={50} color="primary" />
			) : error ? (
				<Alert severity="error">{error}</Alert>
			) : !tareaInfo ? (
				<Alert severity="info">No se encontró la tarea.</Alert>
			) : (
				<Grid item xs={12} sm={8} md={6} lg={5}>
					<Card sx={{ boxShadow: 3, padding: 2, borderRadius: 2 }}>
						<CardHeader
							title={`Seguimiento de Tarea #${tareaInfo.id_tarea}`}
							titleTypographyProps={{ variant: "h6", color: "primary" }}
						/>
						<CardContent>
							{tareaInfo.id_estado === 6 ? (
								<Typography variant="body1" color="error" textAlign="center">
									⚠️ Lo sentimos, este parte ya no está disponible.
								</Typography>
							) : (
								<>
									<Typography variant="body1">
										<strong>Hola{" "}
											{tareaInfo.nombre_cliente || "Sin Nombre"}
										</strong>
									</Typography>
									<Typography variant="body1">
										<strong>Estado Actual:</strong> {tareaInfo.nombre_estado}
									</Typography>
									<Typography variant="body1">
										<strong>Asunto:</strong>{" "}
										{tareaInfo.asunto || "Sin Asunto"}
									</Typography>
									{tareaInfo.dispositivo && (
										<Typography variant="body1">
											<strong>Dispositivo:</strong>{" "}
											{tareaInfo.dispositivo || "No espicificado"} 
										</Typography>
									)}
									{tareaInfo.presupuesto && (
										<Typography variant="body1">
											<strong>Presupuesto:</strong>{" "}
											{tareaInfo.presupuesto || "Todavía no hay presupuesto"} {tareaInfo.iva ? "IVA incluido" : "Más IVA"}
										</Typography>
									)}

									<Typography variant="h6" sx={{ mt: 3 }}>
										Progreso de la Tarea:
									</Typography>

									{/* Stepper de Estados */}
									<Stepper
										activeStep={estados.findIndex(e => e.id === tareaInfo.id_seguimiento)}
										alternativeLabel={!isMobile} // 📌 Si es móvil, no usa etiquetas alternativas
										orientation={isMobile ? "vertical" : "horizontal"} // 📌 Vertical en móviles
										sx={{ mt: 2 }}
									>
										{estados.map((estado, index) => (
											<Step key={index}>
												<StepLabel>
													<Typography variant="body2">{estado.nombre}</Typography>
													<Typography variant="caption" color="textSecondary">
														{estado.fecha}
													</Typography>
												</StepLabel>
											</Step>
										))}
									</Stepper>

									{/* Mensaje de WhatsApp */}
									<Grid container justifyContent="center" alignItems="center" mt={3}>
										<Typography variant="body2" color="textSecondary">
											Envíanos un mensaje si necesitas más información.
										</Typography>
									</Grid>
									<Grid container justifyContent="center" alignItems="center" mt={1}>
										<Button
											variant="contained"
											color="success"
											startIcon={<WhatsAppIcon />}
											onClick={() => window.open(`https://wa.me/34621171103`, "_blank")}
											sx={{
												textTransform: "none",
												fontSize: "16px",
												fontWeight: "bold",
												padding: "10px 20px",
												borderRadius: "8px",
												backgroundColor: "#25D366",
												color: "white",
												"&:hover": {
													backgroundColor: "#1EBE57",
												},
											}}
										>
											Enviar Mensaje
										</Button>
									</Grid>
								</>
							)}
						</CardContent>
					</Card>
				</Grid>
			)}
		</Grid>
	);
};
